// extracted by mini-css-extract-plugin
export default {"returnInspectionInvoices":"InvoicesPage_returnInspectionInvoices__ShTfL","pageHeader":"InvoicesPage_pageHeader__dyU1z"};